module.exports = __webpack_public_path__ + "img/bj3.a8a1954e.png";